var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({width: _vm.size + 'px'}),attrs:{"src":"/img/progress-circle.svg","alt":"Loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }